import React from 'react'
import { useHistory } from 'react-router-dom'
import { B2CCarpayOrderView } from 'parkdepot-shared/gql/graphql'
import OrderDetailedView from '@components/OrderDetailedView/OrderDetailedView.view'

const OpenOrder = ({
    orders,
    selectedOrder,
    setSelectedOrderId
}: {
    orders: B2CCarpayOrderView[]
    selectedOrder: B2CCarpayOrderView
    setSelectedOrderId: (id: string | null) => void
}) => {
    const history = useHistory()

    const onBackClick = () => (orders.length > 1 ? setSelectedOrderId(null) : history.push('/'))

    return <OrderDetailedView selectedOrder={selectedOrder} onBackClick={onBackClick} />
}

export default OpenOrder
